import React,{Component}from 'react'
import Textfield from '@atlaskit/textfield';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Modal, {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    ModalTransition,
  } from '@atlaskit/modal-dialog';
import { getSessionId, getUser ,setUserSession,getToken} from '../util';
export default class CustomerCard extends Component{
    constructor(){
        super()
        this.state={
            companyName:'',
            firstName:'',
            lastName:'',
            designation:'',
            pinCode:'',
            email:'',
            mobileno:'',
            supportPin:'',
            changePin:'',
            modelOpen:false,
            style : {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 1000,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              },

        }
    }
    onModelClick=()=>{
        this.setState({modelOpen:true})  
    }
    onModelCose=()=>{
        this.setState({modelOpen:false, })  
    }
    componentDidMount=()=>{
       this.onUserDetails(getUser().emailid)
    }
    onChangeMobileNum=(evt)=>{
        const re = /^[0-9\b]+$/;
        if (evt.target.value === '' || re.test(evt.target.value)) {
           this.setState({mobileno: evt.target.value})
        }
     }
    onUpdateProfile=()=>{
        if(this.state.companyName===''||this.state.mobileno===''||this.state.firstName===''||this.state.lastName===''){
            alert('All Inputs Are Requied')
        }else{
        let json_data={emailId:getUser().emailid, mobileNo:this.state.mobileno, firstName:this.state.firstName,lastName:this.state.lastName,companyName:this.state.companyName,
        sessionId:getSessionId(),designation:this.state.designation,registerNo:getUser().registerno, }
        fetch(`eadmin/v1/set/profile_update`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken()
        },
        body:(JSON.stringify(json_data)),
        }).then((response) => response.json())
        .then((responseJson) => {
            if(responseJson.status){
                this.onModelClick()
                this.onUserDetails(getUser().emailid)
            }else{
            alert(responseJson.errorMsg)
            }
        }).catch((error) => {
            alert(error)
        });
    }
    }
    onUserDetails=(emailId)=>{
        fetch(`eadmin/v1/set/get_user?emailId=${emailId}` ,{
            method: 'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "x-access-token":getToken()
            },
            }).then((response) => response.json())
            .then((responseJson) => {
                if(responseJson.status ){
                    this.setState({firstName:responseJson.result[0].firstname,lastName:responseJson.result[0].lastname,companyName:responseJson.result[0].companyname,
                    designation:responseJson.result[0].designation,mobileno:responseJson.result[0].mobilenumber})
                }else if(!responseJson.status){
                    alert(responseJson.errorMsg)
                }else{
                    alert('no record found')
                }
        }).catch((error) => {
            alert(error)
        });
    }
    render(){
        return(
            <>
            <Box  elevation={3}
            sx={{
              backgroundColor: 'white',
             height:'130%'
            }}><br/><br/><br/><br/>
          <center><p style={{fontWeight:'600',color:'black',marginRight:'10%'}}>Profile Update</p></center>
            <Grid container spacing={2}>
            <Grid item md={2}/>
                <Grid item md={4}>
                <Grid container spacing={2}>
                    <Grid item xs={1} sm={1} md={2}/>
                        <Grid item xs={1} sm={1} md={8}>
                        <FormControl sx={{ m:1, width: '75%' }}>
                            <label style={{paddingBottom:'10px'}}>First Name</label>
                            <Textfield  aria-label="default text field"   value={this.state.firstName} onChange={(evt)=>this.setState({firstName:evt.target.value.toUpperCase()})}/>
                            </FormControl>
                           
                        </Grid>
                    <Grid item xs={3} md={2} sm={2}/>
                   
                    <Grid item xs={1} sm={1} md={2}/>
                        <Grid item xs={1} sm={1} md={8}>
                        <FormControl sx={{ m:1, width: '75%' }}>
                            <label style={{paddingBottom:'10px'}}>Company Name </label>
                            <Textfield  aria-label="default text field"   value={this.state.companyName}  onChange={(evt)=>this.setState({companyName:evt.target.value.toUpperCase()})}/>
                            </FormControl>
                        
                        </Grid>
                    <Grid item xs={3} md={2} sm={2}/>
                    <Grid item xs={1} sm={1} md={2}/>
                        <Grid item xs={1} sm={1} md={8}>
                            <FormControl sx={{ m:1, width: '75%' }}>
                            <label style={{paddingBottom:'10px'}}>MobileNo</label>
                            <Textfield  aria-label="default text field"   value={this.state.mobileno} onChange={this.onChangeMobileNum} maxLength={10}/>
                            </FormControl>
                        </Grid>
                    <Grid item xs={3} md={2} sm={2}/>
                 
               </Grid>
               </Grid>
               <Grid item md={4}>
               <Grid item xs={1} sm={1} md={2}/>
                        <Grid item xs={1} sm={1} md={8}>
                        <FormControl sx={{ m:1, width: '75%' }}>
                            <label style={{paddingBottom:'10px'}}>Last Name</label>
                            <Textfield  aria-label="default text field"   value={this.state.lastName} onChange={(evt)=>this.setState({lastName:evt.target.value.toUpperCase()})}/>
                        </FormControl>
                        </Grid>
                    <Grid item xs={3} md={2} sm={2}/>
                    <Grid item xs={1} sm={1} md={2}/>
                        <Grid item xs={1} sm={1} md={8}>
                            <FormControl sx={{ m:1, width: '75%' }}>
                            <label style={{paddingBottom:'10px'}}>Designation</label>
                            <Textfield  aria-label="default text field"   value={this.state.designation} onChange={(evt)=>this.setState({designation:evt.target.value.toUpperCase()})}/>
                            </FormControl>
                        </Grid>
                    <Grid item xs={3} md={2} sm={2}/>
            <Grid item md={2}/>
            </Grid>
            <Grid item md={4}></Grid>
            <Grid item md={4}><br/>
            <br/>
            <center><Button style={{marginRight:'20%'}} variant="contained" onClick={this.onUpdateProfile}>Update</Button></center>
            </Grid>
            <Grid item md={4}></Grid>
            </Grid>
            
          </Box>   
          <ModalTransition>
        {this.state.modelOpen && (
          <Modal onClose={this.onModelCose} >
            <ModalHeader>
              <ModalTitle>PROFILE UPDATE</ModalTitle>
            </ModalHeader>
            <ModalBody>
           <label>UPDATE SUCCESSFULLY </label>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.onModelCose} autoFocus>
              OK
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
                </>
        )
    }
        
}